import React from 'react'
import { useState } from 'react';
import Required from '../../../../Components/required/Required'
import { connect } from "react-redux";
import { handleAddSkill, handleDeleteSkill, handleEditSkill } from '../../../../services/actions/actions';

function ContentSkill({ skills, setHandleAddSkills, setHandleEditSkills, setHandleDeleteSkills }) {
    const [isAddingSkill, setIsAddingSkill] = useState(false)
    const [skill, setSkill] = useState('')
    const [skillLevel, setSkillLevel] = useState('')
    const [isEditing, setIsEditing] = useState(false)
    const [selectedId, setSelectedId] = useState('')
    const savesSkills = () => {
        const data = { skill, skillLevel }
        setIsAddingSkill(false)
        setHandleAddSkills(data)
        clearData()
    }
    const clearData = () => {
        setSkillLevel('')
        setSkill('')
        setIsEditing(false)
    }

    const openFormFromEdit = (id, data) => {
        setIsEditing(true)
        const { skill, skillLevel } = data;
        setSkill(skill)
        setSkillLevel(skillLevel)
        setSelectedId(id)
        setIsAddingSkill(true)
    }

    const updateSkills = () => {
        const updated_data = { selectedId, skill, skillLevel }
        setIsAddingSkill(false)
        setHandleEditSkills(updated_data)
    }

    const deleteSkill = () => {
        setIsAddingSkill(false)
        setHandleDeleteSkills(selectedId)
        clearData()
    }
    return (
        <>
            <div className='contentskill'>
                <div className='contentskill-container'>
                    {!isAddingSkill && <div>
                        <span className='block text-xs text-gray-500 py-3 italic'>Maximum of 6 skills are allowed</span>
                        {skills.map((data, idx) => {
                            const { skill, skillLevel } = data;
                            return <div key={idx} className=' cursor-pointer bg-gray-100 rounded-md p-3 hover:bg-gray-200 mb-2' onClick={() => openFormFromEdit(idx, data)}>
                                <div className='flex justify-between items-center'>
                                    <span className='font-semibold text-lg text-gray-700 capitalize'>{skill}</span>
                                    <span className='font-normal text-sm text-gray-600 capitalize'>{skillLevel}</span>
                                </div>
                            </div>
                        })}
                    </div>}
                    {isAddingSkill && <div className='contentskill-form'>
                        <div className="wm_form_group flex flex-col mb-4">
                            <label className="wm_form_label manpro font-semibold">Skill <Required /></label>
                            <input placeholder="Skill" type="text" name="skill" value={skill} onChange={(e) => setSkill(e.target.value)} required className="wm_form_input border-bottom border-gray-300" />
                        </div>
                        <div className="wm_form_group flex flex-col mb-4">
                            <label className="wm_form_label manpro font-semibold">Select skill level</label>
                            <input list="skillslevel" placeholder="Skill level" value={skillLevel} onChange={(e) => setSkillLevel(e.target.value)} name="skilllevel" className="wm_form_input border-bottom border-gray-300" />
                            <datalist id="skillslevel">
                                <option data-rate='1' value="Novice" />
                                <option data-rate='2' value="Beginner" />
                                <option data-rate='3' value="Skillful" />
                                <option data-rate='4' value="Experienced" />
                                <option data-rate='5' value="Expert" />
                            </datalist>
                        </div>
                        <div className='text-center space-x-4'>
                            {!isEditing && <button className='manpro text-white px-3 py-1 rounded-md' style={{ 'backgroundColor': 'var(--color-5)' }} onClick={savesSkills}>Save</button>}
                            {isEditing && <button className='manpro text-white px-3 py-1 rounded-md' style={{ 'backgroundColor': 'var(--color-5)' }} onClick={updateSkills}>Update</button>}
                            {isEditing && <button className='manpro text-red-700 px-3 py-1 rounded-md bg-red-200 ' onClick={deleteSkill}>Delete</button>}
                            <button className='manpro text-gray-700 px-3 py-1 rounded-md border' style={{ 'bordercColor': 'var(--color-5)' }} onClick={() => { setIsAddingSkill(false); clearData() }}>Cancel</button>
                        </div>
                    </div>}
                    {skills.length < 6 && !isAddingSkill && <div className='pt-3 '>
                        <div className='text-center'>
                            <button className='manpro text-white px-3 py-1 rounded-md' style={{ 'backgroundColor': 'var(--color-5)' }} onClick={() => setIsAddingSkill(true)}>Add skills</button>
                        </div>
                    </div>}
                </div>
            </div>
        </>
    )
}

const mapStateToProps = (state) => {
    return state;
};


const mapDispatchToState = (dispatch) => {
    return {
        setHandleAddSkills: (value) => {
            dispatch(handleAddSkill(value))
        },
        setHandleEditSkills: (value) => {
            dispatch(handleEditSkill(value))
        },
        setHandleDeleteSkills: (value) => {
            dispatch(handleDeleteSkill(value))
        },
    }
}

export default connect(mapStateToProps, mapDispatchToState)(ContentSkill)